<template>
    <div class="user" >
       <router-view/>
    </div>
</template>
<script>
    export default {
        mounted(){
            let width=$(window).width();
            let height=$(window).height();
            if(height>=700){
              $('.user').css({height:height+'px'})
            }

            window.onresize=function () {
                let width=$(window).width();
                let height=$(window).height();
                if(height>=700){
                  $('.user').css({height:height+'px'})
                }
            }
        }
    }
</script>

<style scoped>
    .user{
        background-image:url("/imgs/xueyezixun/consultant/student/bg.png") ;
        background-size: auto 100%;
        background-repeat:no-repeat;
        background-size: cover;
        background-position:center 0 ;
    }
</style>
